import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import HotSeriesSection from '@/pages/home/components/HotSeriesSection';
import UpdateFeed from '@/pages/home/components/UpdateFeed';
import IntroSection from '@/pages/home/components/IntroSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroCarousel />
        <HotSeriesSection />
        <UpdateFeed />
        <IntroSection />
      </main>
      <SiteFooter />
    </div>
  );
}